<template>
    <sui-table single-line>
        <sui-table-header>
            <sui-table-row>
                <sui-table-header-cell>Name</sui-table-header-cell>
                <sui-table-header-cell>Value</sui-table-header-cell>
            </sui-table-row>
        </sui-table-header>
        <sui-table-body>
            <sui-table-row v-for="(value, key) in parameters" v-bind:key="key">
                <sui-table-cell>{{ key }}</sui-table-cell>
                <sui-table-cell>{{ value }}</sui-table-cell>
            </sui-table-row>
        </sui-table-body>
    </sui-table>
</template>

<script>

export default {
    name: 'ParametersTable',
    props: {
        parameters: {
            type: Object,
        },
    },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
